import { createFileRoute } from '@tanstack/react-router'
import { VersionHistoryPage } from '@/features/quote-builder/publishing/versions-page'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId/versions')({
  staticData: { title: 'Quote Versions' },
  component: VersionsRoute,
})

function VersionsRoute() {
  const { quoteId } = Route.useParams()
  return <VersionHistoryPage quoteId={quoteId} />
}
